import { createAsyncThunk } from "@reduxjs/toolkit";
import { GET_LANGUAGES } from "../../utils/queries";
import { createGraphQLThunk } from ".";

export const getLanguagesThunk = createAsyncThunk(
  "getLanguagesSlice/getLanguagesThunk",
  createGraphQLThunk({
    query: GET_LANGUAGES,
    getVariables: ({filterInput}) => ({filterInput}),
    responseKey: "getLanguages",
    url: process.env.REACT_APP_API_MASTER_DATA,
  })
);
